/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ConstraintResource } from "./ConstraintResource";
export const ConstraintsResponse = core.serialization.object({
    data: core.serialization.list(ConstraintResource),
});
